<template>
  <div class="landing-filter text-center">
    <div v-if="current_step==1" class="landing-filter-box">
      <div class="container landing-filter-home">
        <div class="row landing-home">
          <div class="col-12 col-lg-5 offset-lg-1 landing-home-left">
          </div>
          <div class="col-12 col-lg-5 landing-home-right">
            <div class="text-left">
              <h2 class="right-title">
                Need Working Capital Term Loan<br /> for your business?
              </h2>
              <p class="right-p">
                <span>We'll help you get the best financing for your business needs.</span>
              </p>
            </div>
            <div class="landing-home-right-mid">
              <b-img class="start-here-img" :src="require('../../assets/imgs/landing-start-here.png')" alt="Landing page start here"></b-img>
              <h2>How much capital does your business need?</h2>
              <div class="start-here-select">
                <b-form-select class="landing-filter-card-select" v-model="capital_need" :options="capital_need_options"></b-form-select>
                <b-button class="start-here-select-btn float-center" variant="primary" @click="onClickApply">Apply</b-button>
              </div>
              <b-img :src="require('../../assets/imgs/landing-bbb-logo.png')" alt="Landing page bbb logo"></b-img>
              <b-img :src="require('../../assets/imgs/landing-mcafee-logo.png')" alt="Landing page mcafee logo"></b-img>
            </div>
            <div class="landing-home-right-bot">
              <div class="row">
                <div class="landing-home-right-bot-col col-lg-4 col-sm-12">
                  <div class="inner-box">
                    <p>INTEREST RATES</p>
                    <h2>starting at 7.99%</h2>
                  </div>
                </div>
                <div class="landing-home-right-bot-col col-lg-4 col-sm-12">
                  <div class="inner-box">
                    <p>LOAN AMOUNTS</p>
                    <h2>up to $500K</h2>
                  </div>
                </div>
                <div class="landing-home-right-bot-col col-lg-4 col-sm-12">
                  <div class="inner-box">
                    <p>REPAYMENT TERMS</p>
                    <h2>12 - 72 months</h2>
                  </div>
                </div>
              </div>
              <div class="landing-home-right-bot-apply">Apply in less than 5 minutes</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="current_step!=1" class="center-progress">
      <b-progress :value="progress" variant="primary">
        <b-progress-bar :value="progress" :label="`${((current_step / max_step) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
      <h3 class="center-progress-h3">Working Capital Term Loan</h3>
    </div>
    <b-card v-if="current_step==2" class="landing-filter-card card-style">
      <h2 class="landing-filter-card-h2">What's your credit score?</h2>
      <div class="landing-filter-card-row row">
        <div class="landing-filter-card-col col-lg-3 col-sm-6" @click="onClickCredit('Excellent(720+)')">
          <b-img :src="require('../../assets/imgs/credit-excellent.png')" alt="Landing page credit excellent"></b-img>
          <h2>Excellent</h2>
          <p>(720+)</p>
        </div>
        <div class="landing-filter-card-col col-lg-3 col-sm-6" @click="onClickCredit('Good(680-719)')">
          <b-img :src="require('../../assets/imgs/credit-good.png')" alt="Landing page credit good"></b-img>
          <h2>Good</h2>
          <p>(680-719)</p>
        </div>
        <div class="landing-filter-card-col col-lg-3 col-sm-6" @click="onClickCredit('Fair(640-679)')">
          <b-img :src="require('../../assets/imgs/credit-fair.png')" alt="Landing page credit fair"></b-img>
          <h2>Fair</h2>
          <p>(640-679)</p>
        </div>
        <div class="landing-filter-card-col col-lg-3 col-sm-6" @click="onClickCredit('Poor(620 or less)')">
          <b-img :src="require('../../assets/imgs/credit-poor.png')" alt="Landing page credit poor"></b-img>
          <h2>Poor</h2>
          <p>(620 or less)</p>
        </div>
      </div>
    </b-card>
    <b-card v-if="current_step==3" class="landing-filter-card card-style">
      <h2 class="landing-filter-card-h2">How long have you been in business?</h2>
      <b-form-select class="landing-filter-card-select" v-model="business_year" :options="business_year_options"></b-form-select>
      <b-button block class="landing-filter-card-btn float-center" variant="primary" @click="onClickYear">Continue</b-button>
    </b-card>
    <b-card v-if="current_step==4" class="landing-filter-card card-style">
      <h2 class="landing-filter-card-h2">What is your annual revenue?</h2>
      <b-form-select class="landing-filter-card-select" v-model="annual_revenue" :options="annual_revenue_options"></b-form-select>
      <b-button block class="landing-filter-card-btn float-center" variant="primary" @click="onClickRevenue">Continue</b-button>
    </b-card>
    <b-card v-if="current_step==5" class="landing-filter-card card-style">
      <h2 class="landing-filter-card-h2">What do you need the financing for?</h2>
      <b-form-select class="landing-filter-card-select" v-model="why_need" :options="why_need_options"></b-form-select>
      <b-button block class="landing-filter-card-btn float-center" variant="primary" @click="onClickWhy">Continue</b-button>
    </b-card>
    <b-card v-if="current_step==6" class="landing-filter-card card-style">
      <h2 class="landing-filter-card-h2">When do you need the financing?</h2>
      <b-form-select class="landing-filter-card-select" v-model="when_need" :options="when_need_options"></b-form-select>
      <b-button block class="landing-filter-card-btn float-center" variant="primary" @click="onClickWhen">Continue</b-button>
    </b-card>
    <b-card v-if="current_step==7" class="landing-filter-card card-style">
      <h2 class="landing-filter-card-h2">What is the name of your business?</h2>
      <b-form-input class="landing-filter-card-select" v-model="business_name" placeholder="Business Name"></b-form-input>
      <b-button block class="landing-filter-card-btn float-center" variant="primary" @click="onClickBusinessName">Continue</b-button>
    </b-card>
    <b-card v-if="current_step==8" class="landing-filter-card card-style">
      <h2 class="landing-filter-card-h2">What's your name?</h2>
      <b-form-input class="landing-filter-card-select" v-model="first_name" placeholder="First Name"></b-form-input>
      <b-form-input class="landing-filter-card-select" v-model="last_name" placeholder="Last Name"></b-form-input>
      <b-button block class="landing-filter-card-btn float-center" variant="primary" @click="onClickName">Continue</b-button>
    </b-card>
    <b-card v-if="current_step==9" class="landing-filter-card card-style">
      <h2 class="landing-filter-card-h2">What's the best way to reach you?</h2>
      <div class="landing-filter-card-input-icon"><b-form-input class="landing-filter-card-select" v-model="phone" :state="phoneState" :formatter="formatter" placeholder="(xxx) xxx-xxxx"></b-form-input><b-img :src="require('../../assets/imgs/landing-phone-icon.png')" alt="Center image"></b-img></div>
      <div class="landing-filter-card-input-icon"><b-form-input class="landing-filter-card-select" v-model="email" :state="emailState" placeholder="Email Address"></b-form-input><b-img :src="require('../../assets/imgs/landing-email-icon.png')" alt="Center image"></b-img></div>
      <b-button block class="landing-filter-card-btn float-center" variant="primary" @click="onClickSubmit">SUBMIT</b-button>
      <div class="landing-filter-card-privacy-icon"><p>Privacy & Security Protected</p><b-img :src="require('../../assets/imgs/landing-lock-icon.png')" alt="Center image"></b-img></div>
      <div class="landing-filter-card-privacy-text"><p>All consumer information is kept strictly confidential. American Credit takes your privacy seriously. By clicking the submit button, you agree to our Privacy Policy, and consent (not required as a condition to purchase a good/service) for American Credit or our affiliates to contact you via telephone, mobile device (including SMS and MMS), and/or email, even if you are on a corporate, state or national Do Not Call Registry. We will never sell your email address to any 3rd party.</p></div>
    </b-card>
    <b-card v-if="current_step==10" class="landing-filter-card card-style">
      <div v-if="qualified">
        <h2 class="landing-filter-card-h2">Congratulations! You've been Pre-Approved!</h2>
        <h5 class="m-t-20">We have received your request and will contact you as soon as possible for the next step.</h5>
        <h3 class="landing-filter-card-h3">To access your funds immediately, please complete a full application:</h3>
        <h4>(It only takes 3 minutes)</h4>
        <b-button block class="landing-filter-card-btn start-application float-center" variant="primary" @click="this.window.location.href='/get-start?product=term-loan'">START FULL APPLICATION NOW</b-button>
      </div>
      <div v-if="!qualified">
        <p class="thank-you">THANK YOU</p>
        <h2 class="landing-filter-card-h2">Thank you for your interest in American Credit.</h2>
        <h4 class="m-t-20">Unfortunately we are currently only able to fund businesses that have been in business for over 2 years, have a 620+ FICO with an annual revenue of >$200,000</h4>
      </div>
    </b-card>
    <div v-if="current_step!=1" class="m-t-20 landing-filter-icons text-center">
      <b-img :src="require('../../assets/imgs/landing-bbb-logo.png')" alt="Center image"></b-img>
      <b-img :src="require('../../assets/imgs/landing-mcafee-logo.png')" alt="Center image"></b-img>
    </div>
  </div>
</template>
<script>

import { mapActions } from "vuex";
import * as types from "../../vuex/types";
import axios from 'axios';
export default {
  name: "WorkingCapitalLandingPageFilter",
  data() {
    return {
      qualified: true,
      current_step: 1,
      max_step: 10,
      credit_score: '',
      capital_need: null,
      capital_need_options: [
        { value: null, text: '<-- Please Select -->' },
        { value: '$5,000 - $10,000', text: '$5,000 - $10,000' },
        { value: '$10,000 – $20,000', text: '$10,000 – $20,000' },
        { value: '$20,000 – $50,000', text: '$20,000 – $50,000' },
        { value: '$50,000 – $100,000', text: '$50,000 – $100,000' },
        { value: '$100,000 - $250,000', text: '$100,000 - $250,000' },
        { value: '$250,000 - $500,000', text: '$250,000 - $500,000' },
        { value: '$500,000 - $1,000,000', text: '$500,000 - $1,000,000' },
        { value: '$1,000,000+', text: '$1,000,000+' }
      ],
      when_need: null,
      when_need_options: [
        { value: null, text: '<-- Please Select -->' },
        { value: 'Within a week', text: 'Within a week' },
        { value: 'Within 2 weeks', text: 'Within 2 weeks' },
        { value: 'Within a month', text: 'Within a month'},
        { value: 'Unsure', text: 'Unsure'}
      ],
      business_year: null,
      business_year_options: [
        { value: null, text: '<-- Please Select -->' },
        { value: 'Startup (less than 2 years)', text: 'Startup (less than 2 years)' },
        { value: '2 – 4 years', text: '2 – 4 years' },
        { value: '5 – 9 years', text: '5 – 9 years'},
        { value: '10+ years', text: '10+ years'}
      ],
      annual_revenue: null,
      annual_revenue_options: [
        { value: null, text: '<-- Please Select -->' },
        { value: 'Below $100,000', text: 'Below $100,000' },
        { value: '$100,000 – $200,000', text: '$100,000 – $200,000' },
        { value: '$200,000 – $300,000', text: '$200,000 – $300,000' },
        { value: '$300,000 – $500,000', text: '$300,000 – $500,000' },
        { value: '$500,000 – $1,000,000', text: '$500,000 – $1,000,000' },
        { value: '$1,000,000 – $3,000,000', text: '$1,000,000 – $3,000,000' },
        { value: '$3,000,000 – $5,000,000', text: '$3,000,000 – $5,000,000' },
        { value: '$5,000,000+', text: '$5,000,000+' }
      ],
      why_need: null,
      why_need_options: [
        { value: null, text: '<-- Please Select -->' },
        { value: 'Equipment Purchase', text: 'Equipment Purchase' },
        { value: 'Accounts receivable finance', text: 'Accounts receivable finance' },
        { value: 'Vehicle purchase', text: 'Vehicle purchase' },
        { value: 'Meet payroll', text: 'Meet payroll' },
        { value: 'Inventory', text: 'Inventory' },
        { value: 'Commercial real estate', text: 'Commercial real estate' },
        { value: 'Scaling or expansion', text: 'Scaling or expansion' },
        { value: 'Marketing', text: 'Marketing' },
        { value: 'Location remodel', text: 'Location remodel' },
        { value: 'Debt refinance', text: 'Debt refinance' },
        { value: 'Buy a business', text: 'Buy a business' },
        { value: 'Start a business', text: 'Start a business' },
        { value: 'Other', text: 'Other' }
      ],
      business_name: '',
      first_name: '',
      last_name: '',
      phone: null,
      email: null
    };
  },
  computed: {
    progress: function() {
      return Math.round(100 / this.max_step) * this.current_step;
    },
    emailState: function() {
      if(this.email == null) return false;
      var filter = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(filter.test(this.email)) {
        return true;
      }
      return false;
    },
    phoneState: function() {
      if(this.phone == null) return false;
      var current = this.phone.replace(/\D/g,'');
      if(current.length < 10) return false;
      return true;
    }
  },
  methods: {
    ...mapActions({
      setFailMessage: types.SET_FAIL_MESSAGE
    }),
    formatter: function(input) {
      // Strip all characters from the input except digits
      input = input.replace(/\D/g,'');
      
      // Trim the remaining input to ten characters, to preserve phone number format
      input = input.substring(0,10);

      // Based upon the length of the string, we add formatting as necessary
      var size = input.length;
      if(size == 0){
              input = input;
      }else if(size < 4){
              input = '('+input;
      }else if(size < 7){
              input = '('+input.substring(0,3)+') '+input.substring(3,6);
      }else{
              input = '('+input.substring(0,3)+') '+input.substring(3,6)+'-'+input.substring(6,10);
      }
      return input; 
    },
    onClickApply: function() {
      if(this.capital_need == null) {
        return this.setFailMessage({
          show: true,
          content: "Please select the capital amount your business needs."
        });
      }
      this.current_step++;
    },
    onClickCredit: function(score) {
      if(score == 'Poor(620 or less)') {
        this.qualified = false;
        this.current_step = 10;
        return;
      }
      this.credit_score = score;
      this.current_step++;
    },
    onClickYear: function() {
      if(this.business_year == null) {
        return this.setFailMessage({
          show: true,
          content: "Please select how many years you have been in business."
        });
      }
      if(this.business_year == 'Startup (less than 2 years)') {
        this.qualified = false;
        this.current_step = 10;
        return;
      }
      this.current_step++;
    },
    onClickRevenue: function() {
      if(this.annual_revenue == null) {
        return this.setFailMessage({
          show: true,
          content: "Please select your annual revenue."
        });
      }
      if(this.annual_revenue == 'Below $100,000' || this.annual_revenue == '$100,000 – $200,000') {
        this.qualified = false;
        this.current_step = 10;
        return;
      }
      this.current_step++;
    },
    onClickWhy: function() {
      if(this.why_need == null) {
        return this.setFailMessage({
          show: true,
          content: "Please select what you need the financing for."
        });
      }
      this.current_step++;
    },
    onClickWhen: function() {
      if(this.when_need == null) {
        return this.setFailMessage({
          show: true,
          content: "Please select when you need the financing."
        });
      }
      this.current_step++;
    },
    onClickBusinessName: function() {
      if(this.business_name == '') {
        return this.setFailMessage({
          show: true,
          content: "Please input your business name."
        });
      }
      this.current_step++;
    },
    onClickName: function() {
      if(this.first_name == '' || this.last_name== '') {
        return this.setFailMessage({
          show: true,
          content: "Please input your first and last name."
        });
      }
      this.current_step++;
    },
    onClickName: function() {
      if(this.first_name == '' || this.last_name== '') {
        return this.setFailMessage({
          show: true,
          content: "Please input your first and last name."
        });
      }
      this.current_step++;
    },
    onClickSubmit: function() {
      if(this.phoneState == false || this.emailState == false) {
        return this.setFailMessage({
          show: true,
          content: "Please input valid phone number and email."
        });
      }
      var leadData = {
        loan_amount: this.capital_need,
        credit_score: this.credit_score,
        year_in_business: this.business_year,
        annual_revenue: this.annual_revenue,
        use_of_finance: this.why_need,
        loan_need_time: this.when_need,
        business_name: this.business_name,
        first_name: this.first_name,
        last_name: this.last_name,
        phone_number: this.phone,
        email_address: this.email,
        campaign: this.$route.query.campaign
      };
      //slack notice webhook
      axios.create({ transformRequest: [(data, _headers) => JSON.stringify(data)] })
                  .post('https://hooks.zapier.com/hooks/catch/11204908/beg2zkp/',leadData);
      //hubspot new lead webhook
      axios.create({ transformRequest: [(data, _headers) => JSON.stringify(data)] })
                  .post('https://hooks.zapier.com/hooks/catch/11204908/begzrid/',leadData);
      //send welcome email to FB new lead
      axios.post("https://api.amcredit.com/apply/sendTransactionalEmail", {customerEmail: this.email, firstName: this.first_name, emailTemplate: 'working-capital-application-completed-welcome', emailSubject: 'Thank you for choosing American Credit for your working capital term loan' })
      .then(res => console.log(res))
      .catch(err => console.log(err.message));
      this.current_step++;
    }
  }
};
</script>

<style scoped lang="scss">
.landing-filter {
  .landing-filter-box {
    width: 100%;
    background-image: url(../../assets/imgs/equipment-financing-landing-page.png);
    background-position: center;
    background-size: cover;
  }
  .landing-filter-home {
    background: transparent;
    .landing-home {
      padding-top: 40px;
      .landing-home-right {
        .right-title {
          text-size-adjust: none;
          font-size: 45px;
          color: rgb(255, 255, 255);
          font-weight: 700;
          font-style: normal;
          white-space: nowrap;
          @media (max-width: 768px) {
            font-size: 30px !important;
          }
        }
        .right-p {
          text-size-adjust: none;
          font-weight: 600;
          font-style: normal;
          font-size: 33px;
          color: rgb(255, 255, 255);
          @media (max-width: 768px) {
            font-size: 24px !important;
          }
        }
        .landing-home-right-mid {
          margin-top: 35px;
          margin-bottom: 200px;
          padding-top: 25px;
          padding-bottom: 15px;
          position: relative;
          background: white;
          border-radius: 5px;
          @media (max-width: 768px) {
            margin-bottom: 420px;
          }
          .start-here-img {
            position:absolute;
            margin-left:-50px;
            top:-40px;
          }
          h2 {
            text-size-adjust: none;
            text-align: center;
            font-size: 30px;
            color: rgb(5, 58, 122);
            font-style: inherit;
            font-weight: bolder;
            max-width: 408px;
            margin: 10px auto;
          }
          .start-here-select {
            margin-top: 20px;
            margin-bottom: 20px;
            .landing-filter-card-select {
              width: 310px;
              margin: 10px auto;
            }
            .start-here-select-btn {
              width: 160px;
              margin-left: 5px;
              height: 38px;
              background-color: rgb(5, 58, 122);
              border-color: rgb(5, 58, 122);
            }
          }
        }
        .landing-home-right-bot {
          position: absolute;
          background: rgba(5,58,122,1);
          border-radius: 10px;
          height: 158px;
          width: 718px;
          padding: 20px;
          left: -100px;
          margin-top: -210px;
          color: rgb(255, 255, 255);
          @media (max-width: 768px) {
            margin-left: 4%;
            width: 92%;
            left: 0;
            height: 388px;
            margin-top: -420px;
          }
          .landing-home-right-bot-col {
            height: 115px;
            p {
              font-size: 14px;
              font-weight: 600;
            }
            h2 {
              font-size: 24px;
              font-weight: 800;
              white-space: nowrap;
            }
            padding: 0;
            .inner-box {
              padding: 12px;
              border-right: 2px solid white;
              @media (max-width: 768px) {
                border-right: none;
                border-bottom: 2px solid white;
              }
            }
          }
          .landing-home-right-bot-col:last-of-type {
            .inner-box {
              border: none;
            }
          }
          .landing-home-right-bot-apply {
            background: rgba(192,34,50,1);
            width:340px;
            height:45px;
            border-radius: 5px;
            font-size: 22px;
            font-weight: 600;
            padding-top: 6px;
            margin: 0 auto;
          }
        }
      }
    }
  }
  .center-progress {
    padding-top: 40px;
    width: 300px;
    margin: 0 auto;
    .center-progress-h3 {
      margin: 0;
      padding: 10px;
      line-height: 31px;
      text-size-adjust: none;
      text-align: center;
      color: rgb(48, 48, 48);
      font-size: 19px;
      font-weight: 600;
    }
  }
  .landing-filter-card {
    border: none;
    .landing-filter-card-row {
      width: 800px;
      margin: 20px auto;
      @media (max-width: 768px) {
        width: 100%;
      }
      .landing-filter-card-col {
        cursor: pointer;
        h2 {
          margin: 5px;
          text-size-adjust: none;
          text-align: center;
          font-size: 26px;
          color: rgb(80, 80, 80);
          font-style: inherit;
          font-weight: bolder;
        }
        p {
          text-size-adjust: none;
          text-align: center;
          font-size: 24px;
          font-weight: 600;
          font-style: normal;
          color: rgb(80, 80, 80);
        }
      }
    }
    .thank-you {
      color: #007bff;
      font-weight: 600;
    }
    h4 {
      max-width: 800px;
      margin: 0 auto;
    }
    .landing-filter-card-h2 {
      text-size-adjust: none;
      text-align: center;
      font-size: 48px;
      font-weight: 600;
      font-style: normal;
      color: rgb(80, 80, 80);
    }
    h5 {
      font-size: 18px;
    }
    .landing-filter-card-h3 {
      text-size-adjust: none;
      text-align: center;
      font-size: 36px;
      font-weight: 600;
      font-style: normal;
      color: rgb(80, 80, 80);
    }
    .landing-filter-card-select {
      width: 310px;
      margin: 10px auto;
    }
    .landing-filter-card-input-icon {
      position: relative;
      margin-top: 20px;
      img {
        position:absolute;
        margin-left:-196px;
        top:4px;
      }
    }
    .landing-filter-card-privacy-icon {
      position: relative;
      p {
        color: #000;
        text-size-adjust: none;
        font-size: 12px;
        margin: 0;
        padding: 0;
        line-height: 16px;
        font-weight: 600;
      }
      img {
        width: 24;
        position:absolute;
        margin-left:-110px;
        top:-4px;
      }
    }
    .landing-filter-card-privacy-text {
      margin: 20px auto;
      max-width: 636px;
      color: #000;
      text-size-adjust: none;
      font-family: Arial, sans-serif;
      font-size: 10px;
      padding: 0;
      margin-bottom: 0;
      line-height: 15px;
      text-align: justify;
      font-weight: 600;
    }
    .landing-filter-card-btn {
      width: 242px;
      height: 46px;
      margin: 30px auto;
      &.start-application {
        width: 300px;
      }
    }
  }
  .landing-filter-icons {
    margin: 60px 0 20px 0;
  }
  .m-t-20 {
    margin-top: 20px;
  }
}

.card-style {
  width: 90%;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// workingCapitalLandingPageFilter.vue?010b3b8a